var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page_container container_history",attrs:{"id":"order-history-screen"}},[_c('div',{staticClass:"box-title title-medium-small"},[_vm._v(_vm._s(_vm.$t('menu.order_history')))]),_c('div',{staticClass:"order-history-content"},[_c('order-history',{staticClass:"order-group-screen",attrs:{"options":{isNoPadding: true}}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }